import styled from "styled-components"
import Container from "@mui/material/Container"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Wrapper = styled(Container)`
  background-color: ${({ theme }) => theme.palette.tertiary.main};
  padding-top: 2em;
  padding-bottom: 2em;
  //display: flex;
  //flex-direction: column;
  //align-items: center;

  h1 {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
    font-weight: 500;
    padding: 1rem 0;
    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: 1.5rem;
      line-height: normal;
    }
  }
  h2 {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
    font-weight: 500;
    padding: 1rem 0;
    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: 1.2rem;
      line-height: normal;
    }
  }
  h4 {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.text.content};
    font-weight: 400;
    padding: 1rem 0;
    //margin-bottom: 1rem;
    ${({ theme }) => theme.breakpoints.down("md")} {
      line-height: normal;
    }
  }

  h5 {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    color: ${({ theme }) => theme.palette.text.content};
    font-weight: bold;
    padding: 0.5em 0;
    margin: 0;
    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: 1.5rem;
      line-height: normal;
    }
  }

  p {
    width: 100%;
    max-width: 628px;
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    color: ${({ theme }) => theme.palette.text.content};
    padding: 0.5rem 0;
    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: 1rem;
      line-height: normal;
    }
  }
  a {
    color: ${({ theme }) => theme.palette.secondary.main};
    text-decoration: none;
    /* display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
  }
  ul,
  ol {
    li {
      width: 100%;
      max-width: 628px;
      margin: 0;
      font-family: ${({ theme }) => theme.fonts.primary};
      font-size: ${({ theme }) => theme.typography.pxToRem(20)};
      color: ${({ theme }) => theme.palette.text.content};
      padding: 0.5rem 0;
      ${({ theme }) => theme.breakpoints.down("md")} {
        font-size: 1rem;
        line-height: normal;
      }
    }
  }
`

export const Button = styled(CustomButton)`
  margin-top: 1em;
`
